import React from "react";
import { Card, CardContent, Grid, Typography } from "@mui/material";
import { classifySeries } from "../utils/classifySeries";
import { priceToEarningsCalc } from "../utils/util";
import { spearmanCorrelation, getHistoricValues } from "../utils/classifyCorrelation";
import { roundTo2IfNumber } from "../utils/numberFormatter";

export default function MetricsComponent({ ticker, apiData, valOneYear, temPermissao }) {
    const ultimos10 = apiData.financial_data.financials?.slice(-10);
    const lastYear = apiData.financial_data.financials?.slice(-1);
    const epsUltimos10 = ultimos10.map(item => item.eps);
    const revenueUtimos10 = ultimos10.map (item => item.revenue);
    const arrNetIncome = apiData.financial_data.financials?.map (item => item.netIncome);
    const objHistoricPrices = apiData.historicPrices ?? apiData.historicPrices ?? {};
    const arrHistoricPrices = getHistoricValues(objHistoricPrices);

    //classify series Revenue and EPS
    const clEPs = classifySeries(epsUltimos10);
    const clRevenue = classifySeries(revenueUtimos10);

    //calculate correlation

    let corrNetIncomePrice = "Only Members. Contact: asxstockgraphs@gmail.com"
    if (temPermissao){
      corrNetIncomePrice = spearmanCorrelation(arrNetIncome,arrHistoricPrices);
    } 

  return (
    <Card
      sx={{
        backgroundColor: "#1e1e1e",
        color: "#fff",
        borderRadius: "16px",
        padding: "16px",
        width: "100%",
        maxWidth: "800px",
        margin: "0 auto",
        boxShadow: "0 4px 12px rgba(0,0,0,0.5)",
      }}
    >

      <CardContent>
        <Grid container spacing={2}>

          <Grid item xs={6}>
            <Typography variant="body2" color="gray">
              Revenue Growth
            </Typography>
            <Typography variant="body1">
              {clRevenue}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" color="gray">
              EPS Growth
            </Typography>
            <Typography variant="body1">
              {clEPs}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" color="gray">
              P/E Ratio
            </Typography>
            <Typography variant="body1">{priceToEarningsCalc(lastYear[0].eps, apiData.lastPrice)}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" color="gray">
              5 Years Avg Dividend
            </Typography>
            <Typography variant="body1">
              {apiData?.info?.fiveYearAvgDividendYield ?? 0}%
            </Typography>
          </Grid>
        </Grid>
        <br></br>
        <Grid container spacing={2}>

          <Grid item xs={6}>
            <Typography variant="body2" color="gray">
              Correlation Net Income x Price
            </Typography>
            <Typography variant="body1">
              {roundTo2IfNumber(corrNetIncomePrice)}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" color="gray">
              Price Growth 1 year
            </Typography>
            <Typography variant="body1">
              {roundTo2IfNumber(valOneYear)}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" color="gray">
              
            </Typography>
            <Typography variant="body1">{}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" color="gray">
              
            </Typography>
            <Typography variant="body1">
              {}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
